module.exports = __webpack_public_path__ + "static/media/checkmark_326.f26a3480.png";